import styled from "styled-components";
// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import SelectPassengerCard from "../components/select-passenger-list/styles/SelectPassengerCard-APP_CLIENT.styled";
import StyledLocalLink from "features/shared/components/link/styles/StyledLocalLink.styled";
import DefaultSuccessBanner from "features/shared/components/banners/success-banner/styles/SuccessBanner.styled";

const StyledSelectPassengerPage = styled.div`
  padding: 24px 0;

  ${DefaultSuccessBanner} {
    margin-bottom: 24px;
  }
  ${StyledLocalLink} {
    margin: 24px 0;
  }

  ${SelectPassengerCard} {
    margin-top: 24px;
  }
`;
export default StyledSelectPassengerPage;
